const routes = [
    {
        path: "/board/members",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission:'boardmember_index'
        }
    }
];

export default routes;
